import * as React from 'react';
import { FC, RefObject, useCallback } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';

import useVisibilitySensor from 'hooks/use-visibility-sensor';
import { NotificationDetails } from 'state/loyalty/hooks/types';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';

import {
  ArrowWrapper,
  Container,
  Content,
  DescriptionTextBlock,
  ImageContainer,
  TitleAndDescription,
  TitleText,
  Wrapper,
} from './loyalty-notification-card.styled';

const LoyaltyNotificationCard: FC<{
  idx: number;
  notification: NotificationDetails;
}> = ({ idx, notification: { title, image, description, path, id } }) => {
  const mainImage = image?.locale;
  const titleText = title?.locale;
  const descriptionContent = description?.localeRaw;
  const { visibilityRef, isVisible } = useVisibilitySensor({
    triggerWhenFullyVisible: true,
    threshold: 1,
    rootMargin: null,
    isSingleton: false,
    initialIsVisible: false,
  });
  const { logEvent } = useMParticleContext();

  const onClickHandler = useCallback(() => {
    const eventAttributes = {
      'Marketing Tile ID': id,
      'Marketing Tile Name': titleText,
    };
    logEvent(CustomEventNames.MARKETING_TILE_CLICK, EventTypes.Navigation, eventAttributes);
  }, [id, logEvent, titleText]);

  if (!mainImage || !titleText || !descriptionContent) {
    return null;
  }

  return (
    <Wrapper>
      <Container
        ref={visibilityRef as RefObject<HTMLAnchorElement>}
        $isVisible={isVisible}
        $idx={idx}
        to={path?.locale || '/'}
        onClick={onClickHandler}
      >
        <ImageContainer image={mainImage} alt={titleText} />
        <Content>
          <TitleAndDescription>
            <TitleText>{titleText}</TitleText>
            <DescriptionTextBlock content={descriptionContent} />
          </TitleAndDescription>
          <ArrowWrapper>
            <Icon icon="next" color="primary" width="24px" aria-hidden />
          </ArrowWrapper>
        </Content>
      </Container>
    </Wrapper>
  );
};

export default LoyaltyNotificationCard;
